/**
 * Created by hj on 2017/8/24.
 * change by Jession on 2018/04/04
 * 财务管理 -- 其他信息录入
 */
import React from 'react';
import {Button, Row, Col, Modal, Radio, Select, Input, message, DatePicker, InputNumber} from 'antd';
import {hashHistory} from 'react-router';
import {DmsTab, TableView, FilterBox, AdvanceFormNew} from 'Components';
import moment from 'moment';
import {openNotice, exportExcel, config, objectSerial} from 'Utils';
import {getOtherInforList, addOtherInfor, exportOtherInforList} from '../../service/financialMgm';

class OtherInfoList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['其他信息录入'],
            showHideBtnIndex: 0,
            key: 0,
            filterBoxVisible: false,
            rows: [
                // {
                //   id: 1,
                //   name: '浙江电工张华',
                //   type: '现金',
                //   amount: '500000'
                // },
                // {
                //   id: 2,
                //   name: '浙江电工张华',
                //   type: '欠款',
                //   amount: '250000'
                // }
            ],
            total: 1,
            searchObj: {
                otherType: '',  // 费用类型
                startDate: '',  // 开始时间
                endDate: '',  // 结束时间
                s: 10,
                p: 1
            },
            visible: false,
            costType: [
                {value: '待垫运费', text: '待垫运费'},
                {value: '其他业务支出', text: '其他业务支出'},
                {value: '其他业务收入', text: '其他业务收入'},
                {value: '房租', text: '房租'},
                {value: '日常办公易耗品开支', text: '日常办公易耗品开支'},
                {value: '水电费', text: '水电费'},
                {value: '税费', text: '税费'},
                {value: '通讯费', text: '通讯费'}
            ],
            addObj: { // 新增其他信息
                otherDate: moment(),  // 日期
                otherCount: '', // 金额
                otherType: '待垫运费',  // 费用类型
                remark: ''  // 备注
            },
            loading: true
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
    }

    advanceReset() {
        /* 重置 */
        this.setState({
            searchObj: {
                // ...this.state.searchObj,
                otherType: '',  // 费用类型
                startDate: '',  // 开始时间
                endDate: '',  // 结束时间
                s: 10,
                p: 1
            }
        }, () => {
            this.initData();
            this.setState({filterBoxVisible: !this.state.filterBoxVisible});
        });
        // openNotice('success', '操作成功', '');
        // this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
    };

    advanceSubmit(form) {  // 查询
        // openNotice('success', '操作成功', '');
        // this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
        this.setState({searchObj: {...this.state.searchObj, p: 1}}, () => {
            this.initData();
            this.setState({filterBoxVisible: !this.state.filterBoxVisible});
        })
    };

    setFilterParam(name, value) {
        if (name === 'shipTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startDate: value.from ? (value.from + ' 00:00:00') : '',
                    endDate: value.end ? (value.end + ' 23:59:59') : ''
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    pageChange(page, pageSize) {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, () => {
            this.initData();
        });
    }

    goView(url) {
        hashHistory.push(url);
    }

    toEdit(index) {
        /* 编辑 */
        this.goView('card/add/' + this.state.rows[index].id);
    }

    showHideBtn(index) {
        this.setState({
            showHideBtnIndex: index
        });
    }

    hideBtn() {
        this.setState({
            showHideBtnIndex: ''
        });
    }

    /* 保存关闭 */
    saveClose = (obj) => {
        // console.log(this.state.addObj);
        // console.log(obj);
        this.postAddOtherInfor(() => {
            if (obj.hide) {
                // 保存并关闭
                this.setState({visible: false});
            }
            this.clearAddParam();
        });
    }

    /* 清除新增时的参数 */
    clearAddParam() {
        this.setState({
            addObj: {
                otherDate: moment(),  // 日期
                otherCount: '', // 金额
                otherType: '待垫运费',  // 费用类型
                remark: ''  // 备注}
            }
        })
    }

    handleCancel = () => {
        this.setState({visible: false}, () => {
            this.clearAddParam();
        });
    }

    /* 新增显示新增表格 */
    addFn = () => {
        this.setState({visible: true});
    }

    /* 新增其他信息记录 */
    addChange(name, val) {
        switch (name) {
            // case 'otherDate':  // 日期
            // break;
            // case 'otherCount': // 金额
            // break;
            // case 'otherType':  // 费用类型
            // break;
            case 'remark':  // 备注
                val = val.target.value;
                break;
        }
        // console.log(val);
        this.setState({
            addObj: {
                ...this.state.addObj,
                [name]: val
            }
        })
    }

    /* 提交新增其他信息接口 */
    postAddOtherInfor(callback) {
        var obj = {...this.state.addObj};
        if (!obj.otherDate) {
            message.warning('请选择日期');
            return;
        } else if (!obj.otherCount) {
            message.warning('请输入金额');
            return;
        } else if (!obj.otherType) {
            message.warning('请选择费用类型');
            return;
        }
        obj.otherDate = moment(obj.otherDate).format('YYYY-MM-DD HH:mm:ss');
        addOtherInfor(obj).then(res => {
            if (res.status) {
                this.initData();
                openNotice('success', '新增成功', '');
                if (typeof callback == 'function')
                    callback();
            } else {
                message.error(res.message);
            }
        });
    }

    /*获取列表数据*/
    initData() {
        var obj = this.state.searchObj;
        this.setState({
            loading: true
        })
        getOtherInforList(obj).then(result => {
            if (result.status) {
                this.setState({
                    rows: result.data || [],
                    total: result.total,
                    loading: false
                })
            } else {
                message.error(result.message);
            }
        })
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    /* 导出Excel */
    exportExcel() {
        let params = this.state.searchObj;
        let url = `${config.server}/api/v1/dms/trans/othermsg/exportOthermsg?${objectSerial(params)}`;
        window.open(url);
    }

    render() {
        const {opts, key, filterBoxVisible, rows, total, searchObj, showHideBtnIndex, visible, costType, loading} = this.state;
        var self = this;
        const advanceProps = {
            fileds: [
                {
                    name: 'otherType',
                    label: '费用类型',
                    text: '选择费用类型',
                    options: [
                        {value: '', text: '全部'},
                        {value: '待垫运费', text: '待垫运费'},
                        {value: '其他业务支出', text: '其他业务支出'},
                        {value: '其他业务收入', text: '其他业务收入'},
                        {value: '房租', text: '房租'},
                        {value: '日常办公易耗品开支', text: '日常办公易耗品开支'},
                        {value: '水电费', text: '水电费'},
                        {value: '税费', text: '税费'},
                        {value: '通讯费', text: '通讯费'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.otherType || ''
                },
                {
                    name: 'shipTime',//startCreatedDate, endCreatedDate
                    label: '费用日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.from || '',
                        end: searchObj.end || ''
                    }
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '编号',
                    dataIndex: 'code'
                }, {
                    title: '费用',
                    dataIndex: 'otherType'
                }, {
                    title: '日期',
                    dataIndex: 'otherDate'
                }, {
                    title: '费用金额',
                    dataIndex: 'otherCount'
                }, {
                    title: '备注',
                    dataIndex: 'remark'
                }
            ],
            rows
        };
        return <div className="dms-body">
            <DmsTab options={opts} defaultKey={key}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button onClick={this.addFn} style={{position: 'absolute', bottom: 8, left: 0}}>新增</Button>
                    <Button style={{marginLeft: 10}} onClick={this.exportExcel.bind(this)}
                            style={{position: 'absolute', bottom: 8, right: 0}} icon="export">导出</Button>
                </div>
                <TableView {...tableViewProps}/>
            </div>

            <Modal
                visible={visible}
                title="新增其他信息"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={800}
                footer={[
                    <Button key="saveClose" type="primary"
                            onClick={this.saveClose.bind(this, {hide: true})}>保存关闭</Button>,
                    <Button key="saveContinue" onClick={this.saveClose}>保存继续</Button>,
                    <Button key="cancel" onClick={this.handleCancel}>取消</Button>
                ]}
            >
                <div>
                    <Row style={{marginBottom: 10}}>
                        <Col span={8}>
                            <label className="ant-form-item-required">日期</label>
                            <DatePicker style={{marginLeft: 10}} onChange={this.addChange.bind(this, 'otherDate')}
                                        value={this.state.addObj.otherDate}/>
                        </Col>
                        <Col span={8}>
                            <label className="ant-form-item-required">金额</label>
                            <InputNumber style={{marginLeft: 10, width: 150}}
                                         onChange={this.addChange.bind(this, 'otherCount')}
                                         value={this.state.addObj.otherCount}/>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: 10}}>
                        <Col>
                            <label className="ant-form-item-required">费用类型</label>
                            <Select style={{marginLeft: 10, width: 150}} defaultValue={costType[0].value}
                                    onChange={this.addChange.bind(this, 'otherType')}
                                    value={this.state.addObj.otherType}>
                                {
                                    costType.map(x => {
                                        return <Select.Option key={x.value} value={x.value}>{x.text}</Select.Option>
                                    })
                                }
                            </Select>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: 10}}>
                        <Col>
                            <label>备注</label>
                            <Input.TextArea onChange={this.addChange.bind(this, 'remark')}
                                            value={this.state.addObj.remark}/>
                        </Col>
                    </Row>
                </div>

            </Modal>

        </div>
    }
}
;
export default OtherInfoList;
// export default Form.create()(OtherInfoList);


// WEBPACK FOOTER //
// ./src/routes/financialMgm/otherInfoList.js